export default "__VITE_ASSET__DQ7msi77__"